export default {
    stringifyNumber(n) {
        if (n == 0) return 'First Contact';

        var special = ['zeroth', 'First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth', 'Ninth', 'Tenth', 'Eleventh', 'Twelfth', 'Thirteenth', 'Fourteenth', 'Fifteenth', 'Sixteenth', 'Seventeenth', 'Eighteenth', 'Nineteenth'];
        var deca = ['Twent', 'Thirt', 'Fort', 'Fift', 'Sixt', 'Sevent', 'Eight', 'Ninet'];

        if (n < 20) return special[n] + ' Follow-up';
        if (n % 10 === 0) return deca[Math.floor(n / 10) - 2] + 'ieth' + ' Follow-up';

        return deca[Math.floor(n / 10) - 2] + 'y-' + special[n % 10] + ' Follow-up';
    },
    changeDateFormat(date){
      let Year = date.getFullYear();
      let Month = date.getMonth() + 1;
      let Day = date.getDate();

      if (Month < 10) Month = '0' + Month;
      if (Day < 10) Day = '0' + Day;

      return Year + '-' + Month + '-' + Day;
    }
};
